import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import { graph } from '@adc/constants'

const FORECLOSURE_PRODUCT_TYPES = new Set([
  graph.enums.ProductType.TRUSTEE,
  graph.enums.ProductType.FCL_MARKETING,
])

const ListingReserve = ({ listing, elmId }) => {
  const [reserveLabel, reserveValue] = ListingReserve.rawTuple(listing)

  return (
    <div data-elm-id={`reserve_amount_${elmId}`}>
      <label>{reserveLabel}:</label>
      <span>{reserveValue}</span>
    </div>
  )
}

/**
 * NOTE: This is attached here with intention. Products needs this reserve logic but usually all have a slightly
 * different way of displaying it inline: some split with dots, some default with '-' and some display nothing if the
 * reserve is empty.
 */
ListingReserve.rawTuple = (
  listing,
  emptyValue = '',
  callerReserveOverride = null
) => {
  const mostAccurateReserveValueAvailable =
    callerReserveOverride || listing.reserve_price
  const value = mostAccurateReserveValueAvailable
    ? numeral(mostAccurateReserveValueAvailable).format('$0,0')
    : emptyValue

  const label = FORECLOSURE_PRODUCT_TYPES.has(
    listing.listing_configuration?.product_type
  )
    ? 'Est. Credit Bid'
    : 'Reserve Amount'

  return [label, value]
}

ListingReserve.propTypes = {
  listing: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
}

export default ListingReserve
